// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero-module--wrapper--1ihuP","text_container":"Hero-module--text_container--205Th"};